import React, { useState, createContext, useContext } from 'react';
interface AuthContextType {
  isAuthenticated: boolean;
  isInitialized: boolean;
  login: (email: string, password: string) => Promise<void>;
  loginWithSocial: (provider: string) => Promise<void>;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | null>(null);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialized, setIsInitialized] = useState(true);
  const login = async (email: string, password: string) => {
    // Check for specific credentials
    if (email === 'sven.schulte@pezula.net' && password === 'Letmein@0815') {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsAuthenticated(true);
    } else {
      throw new Error('Invalid credentials');
    }
  };
  const loginWithSocial = async (provider: string) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsAuthenticated(true);
  };
  const logout = () => {
    setIsAuthenticated(false);
  };
  return <AuthContext.Provider value={{
    isAuthenticated,
    isInitialized,
    login,
    loginWithSocial,
    logout
  }} data-id="element-582">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}